import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Search } from '../../models/searchModel';
import { ExcelJson } from '../../models/excelData';
import { BillingService } from '../../services/billing.service';
import { AuthService } from '../../services/auth.service';
import { SingleTableModel } from '../../models/singleTableModel';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDate, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { ExportService } from '../../services/export.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'app-tenantBilling',
  templateUrl: './tenantBilling.component.html',
  styleUrls: ['./tenantBilling.component.css'],
  standalone: false
})
export class TenantBillingComponent {
  @Input() tenantId!: string;
  @Input() accessKey!: string;
  @Input() mode: string = '';
  searchData: Search = new Search('', '', '', '','', '', { tenantId: '', transactionEpochTime: 0, transactionId: '' });
  toDate: NgbDate = NgbDate.from({ year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() })!;
  fromDate: NgbDate = NgbDate.from({ year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() })!;
  searchTransactionId: string = '';


  transactionAudit: SingleTableModel[] = [];
  filteredTransactions: SingleTableModel[] = [];
  p: number = 1;
  datePage: number = 1;
  allTenantsPage: number = 1;
  errorMessage: string = '';
  isAdminUser: boolean = false;
  isLoading: boolean = false;
  fileName: string = '';

  constructor(private billingService: BillingService, private route: ActivatedRoute, private router: Router, private authService: AuthService, private datePipe: DatePipe, private exportService: ExportService, private errorService: ErrorService, private calendar: NgbCalendar) {

  }

  ngOnInit(): void {
    this.isAdminUser = this.authService.IsAdminUser$.value;
    this.route.queryParams.subscribe(params => {
      this.tenantId = params['tenantId'];
      this.accessKey = params['accessKey'];
      this.mode = params['mode'] ?? '';
    });
    this.searchData.tenantAccessKey = this.accessKey;
    this.searchData.tenantId = this.tenantId;
    this.resetData();
  }

  resetData() {
    this.p = 1;
    this.datePage = 1;
    this.transactionAudit = [];
    this.filteredTransactions = [];
    this.searchData.lastEvaluatedKey.tenantId = '';
    this.searchData.lastEvaluatedKey.transactionId = '';
    this.searchData.lastEvaluatedKey.transactionEpochTime = 0;
  }

  billingByTransactionId() {
    this.resetData();
    this.isLoading = true;
    this.p = 1;
    this.billingService.searchByTransactionIdWithLimit(this.searchData).subscribe((data) => {
      if (data != null) {
        if (data.hasOwnProperty('message')) {
          this.errorMessage = data.message;
        }
        else {
          this.errorMessage = '';
          if (this.transactionAudit.length == 0)
            this.transactionAudit = data.Items;
          else if (data.Items.length > 0)
            this.transactionAudit.push(...data.Items);
          if (this.filteredTransactions.length == 0)
            this.filteredTransactions = data.Items;
          else if (data.Items.length > 0)
            this.filteredTransactions.push(...data.Items);

          if (data?.LastEvaluatedKey?.transactionId != undefined && data?.LastEvaluatedKey?.transactionId != '') {
            this.searchData.lastEvaluatedKey = data.LastEvaluatedKey;
            console.log(data.LastEvaluatedKey);
            this.keepTransactionIdSearchAlive();
          }
          else {
            console.log('last');
            this.isLoading = false;
          }
        }
      }
      else {
        this.isLoading = false;
      }
    }, (error) => {
      if (error instanceof HttpErrorResponse) {
        this.errorMessage = `Error: ${error.error.message}`;
      } else {
        this.errorMessage = `Error: ${error.message}`;
      }
      this.isLoading = false;
      this.errorService.alertError(error);
    });
  }

  keepTransactionIdSearchAlive = () => {
    this.billingService.searchByTransactionIdWithLimit(this.searchData).subscribe((data) => {
      if (data.hasOwnProperty('message')) {
        this.errorMessage = data.message;
      }
      else {
        this.errorMessage = '';
        if (this.transactionAudit.length == 0)
          this.transactionAudit = data.Items;
        else if (data.Items.length > 0)
          this.transactionAudit.push(...data.Items);
        if (this.filteredTransactions.length == 0)
          this.filteredTransactions = data.Items;
        else if (data.Items.length > 0)
          this.filteredTransactions.push(...data.Items);

        if (data?.LastEvaluatedKey?.transactionId != undefined && data?.LastEvaluatedKey?.transactionId != '') {
          this.searchData.lastEvaluatedKey = data.LastEvaluatedKey;
          console.log(data.LastEvaluatedKey);
          this.keepTransactionIdSearchAlive();
        }
        else {
          console.log('last');
          this.isLoading = false;
        }
      }
    }, (error) => {
      if (error instanceof HttpErrorResponse) {
        this.errorMessage = `Error: ${error.error.message}`;
      } else {
        this.errorMessage = `Error: ${error.message}`;
      }
      this.isLoading = false;
      this.errorService.alertError(error);
    });

  }

  billingByDate() {
    this.resetData();
    this.isLoading = true;
    if (this.fromDate == null || this.toDate == null) {
      this.isLoading = false;
      alert('Please enter valid dates');
    }
    else {
      try {
        var fromDt = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
        var toDt = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
        if (fromDt > toDt) {
          this.isLoading = false;
          alert('To Date should be after from date');
          return;
        }
        else if (fromDt > new Date() || toDt > new Date()) {
          this.isLoading = false;
          alert('Dates cannot be from future');
          return;
        }
        this.searchData.fromDate = this.datePipe.transform(fromDt, 'MM-dd-yyyy') || '';
        this.searchData.toDate = this.datePipe.transform(toDt, 'MM-dd-yyyy') || '';
        this.billingService.searchByDateWithLimit(this.searchData).subscribe((data) => {
          if (data != null) {
            if (data.hasOwnProperty('message')) {
              this.errorMessage = data.message;
              this.isLoading = false;
            }
            else {
              this.errorMessage = '';
              if (this.transactionAudit.length == 0)
                this.transactionAudit = data.Items;
              else
                this.transactionAudit.push(data.Items ?? []);
              if (this.filteredTransactions.length == 0)
                this.filteredTransactions = data.Items;
              else
                this.filteredTransactions.push(...data.Items ?? []);

              if (data?.LastEvaluatedKey?.transactionId != undefined && data?.LastEvaluatedKey?.transactionId != '') {
                this.searchData.lastEvaluatedKey = data.LastEvaluatedKey;
                console.log(data.LastEvaluatedKey);
                this.keepDateSearchAlive();
              }
              else {
                console.log('last');
                this.isLoading = false;
              }
            }
          }
          else {
            this.isLoading = false;
          }
        }, (error) => {
          if (error instanceof HttpErrorResponse) {
            this.errorMessage = `Error: ${error.error.message}`;
          } else {
            this.errorMessage = `Error: ${error.message}`;
          }
          this.isLoading = false;
          this.errorService.alertError(error);
        });


      }
      catch (e) {
        console.log(e);
        this.isLoading = false;
        alert('Please enter valid dates');
      }
    }
  }

  keepDateSearchAlive = () => {
    this.billingService.searchByDateWithLimit(this.searchData).subscribe((data) => {
      if (data.hasOwnProperty('message')) {
        this.errorMessage = data.message;
      }
      else {
        this.errorMessage = '';
        if (this.transactionAudit.length == 0)
          this.transactionAudit = data.Items;
        else
          this.transactionAudit.push(...data.Items ?? []);
        if (this.filteredTransactions.length == 0)
          this.filteredTransactions = data.Items?.filter((x: any) => x.messageFrom != 'REST');
        else
          this.filteredTransactions.push(...data.Items?.filter((x: any) => x.messageFrom != 'REST') ?? []);

        if (data?.LastEvaluatedKey?.transactionId != undefined && data?.LastEvaluatedKey?.transactionId != '') {
          this.searchData.lastEvaluatedKey = data.LastEvaluatedKey;
          console.log(data.LastEvaluatedKey);
          this.keepDateSearchAlive();
        }
        else {
          console.log('last');
          this.isLoading = false;
        }
      }
    }, (error) => {
      if (error instanceof HttpErrorResponse) {
        this.errorMessage = `Error: ${error.error.message}`;
      } else {
        this.errorMessage = `Error: ${error.message}`;
      }
      this.isLoading = false;
      this.errorService.alertError(error);
    });

  }
  
  exportToCsv(): void {
    let exportRows: SingleTableModel[] = [];
    this.filteredTransactions.forEach(transaction => {
      exportRows.push(new SingleTableModel(transaction.id, transaction.transactionId, transaction.email, transaction.flow_id, transaction.isActive, transaction.recordType, transaction.accessKey, transaction.name, transaction.transactionJSON, transaction.tsn, this.datePipe.transform(new Date(transaction.updateDate), 'yyyy-MM-dd HH:mm:ss')!, transaction.updateEpochTime, transaction.apiKey, transaction.accessAssociation, '', localStorage.getItem('UserName') ?? '',''));
    });
    this.fileName = 'Transaction_details_' + this.filteredTransactions[0].id + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');
    this.exportService.exportToCsv(exportRows, this.fileName, ['tenantId', 'transactionId', 'flow_id', 'tsn', 'transactionJSON', 'tranactionDate'],
      ['Tenant Id', 'Transaction Id', 'Flow ID', 'TSN', 'Transaction JSON', 'Date']);
  }

  exportToExcel(): void {
    const edata: Array<ExcelJson> = [];
    const udt: ExcelJson = {
      data: [
        //{ A: 'Tenant Details' }, // title
        { A: 'Tenant Id', B: 'Transaction Id', C: 'Flow ID', D: 'TSN', E: 'Transaction JSON', F: 'Date' }, // table header
      ],
      skipHeader: true
    };
    //udt.data.push(this.filteredTransactions);
    this.filteredTransactions.forEach(transaction => {
      udt.data.push({
        A: transaction.id,
        B: transaction.transactionId,
        C: transaction.flow_id,
        D: transaction.tsn,
        E: transaction.transactionJSON,
        F: this.datePipe.transform(new Date(transaction.updateDate), 'yyyy-MM-dd HH:mm:ss')
      });
    });
    edata.push(udt);
    this.fileName = 'Transaction_details_' + this.filteredTransactions[0].id + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd HH:mm:ss');
    this.exportService.exportJsonToExcel(edata, this.fileName);
  }
}
